
import { Vue, Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import { SystemApi } from "../../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../../atoms/FieldLabel.vue";
import FormError from "../../atoms/FormError.vue";
import ActionButton from "../../atoms/ActionButton.vue";
// @ts-ignore
import { MonthPickerInput } from "vue-month-picker";
import Store from "../../../store";
import { InstructionLevel } from "../../../types";

@Options({
  components: {
    Field,
    Form,
    FieldLabel,
    ActionButton,
    MonthPickerInput,
    FormError
  }
})
export default class MonthlyReport extends Vue {
  @Ref("form") form?: HTMLElement;
  selected: Date = new Date();
  defaultYear = this.selected.getMonth() == 0 ? this.selected.getFullYear() - 1 : this.selected.getFullYear();
  defaultMonth = this.selected.getMonth() == 0 ? 12 : this.selected.getMonth();
  onManthChange(event: { from: Date }) {
    this.selected = event.from;
  }
  /**
   * CSV出力ボタンクリックアクション
   * 当月より前の月のCSVデータをダウンロードする
   * @param None
   * @return void
   */
  async onOutputButtonClick() {
    const encoding = require("encoding-japanese");
    try {
      const y4m2 = new Date();
      const selectedYearMonth = Number(
        String(this.selected.getFullYear()) + (this.selected.getMonth() + 1).toString().padStart(2, "0")
      );
      const nowYearMonth = Number(String(y4m2.getFullYear()) + (y4m2.getMonth() + 1).toString().padStart(2, "0"));
      if (selectedYearMonth >= nowYearMonth) {
        Store.getInstance().setInstructionContent(
          InstructionLevel.Alert,
          "月末に当月分が確定します。当月より前の月を選択してください。"
        );
        return;
      }
      const response = await new SystemApi().exportBillintCsv({
        period: `${this.selected.getFullYear()}${("00" + (this.selected.getMonth() + 1)).slice(-2)}`
      });
      const str_array = encoding.stringToCode(response.data);
      const sjis_array = encoding.convert(str_array, "SJIS", "UNICODE");
      const uint8_array = new Uint8Array(sjis_array);

      const url = window.URL.createObjectURL(new Blob([uint8_array], { type: "text/csv;charset=Shift_JIS" }));
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.setAttribute(
        "download",
        `月別受検数_${`${this.selected.getFullYear()}${("00" + (this.selected.getMonth() + 1)).slice(-2)}`}.csv`
      );
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
    } catch (err) {
      if (err.response.data.detail && err.response.data.detail.length) {
        Store.getInstance().setInstructionContent(InstructionLevel.Alert, err.response.data.detail);
      } else {
        Store.getInstance().setInstructionContent(
          InstructionLevel.Alert,
          "エラーが発生しました。時間を置いて再度試すか、窓口までお問い合わせください。"
        );
      }
    }
  }
}
